module.exports = __webpack_public_path__ + "static/img/b203.c5d6dbe2.png";